module.exports = __webpack_public_path__ + "static/media/avatar-shanai.edac7f37.png";